module.exports = __webpack_public_path__ + "img/Color S019.ac840fcd.jpg";